import CustomColorCell from './CustomColorCell';

export default CustomColorCell;
